export default {
  navigationBarTitleText: '增项详情'
};
